export default class DataRevealFields {

  protected get dataCheckFieldName() {
    return "data-check-field";
  }
  protected get dataRevealFieldName() {
    return "data-reveal-field";
  }

  protected get dataHideFieldName() {
    return "data-hide-field";
  }

  protected get selectorAll() {
    return `input:radio[${this.dataCheckFieldName}], input:checkbox[${this.dataCheckFieldName}], option[${this.dataCheckFieldName}]`;
  }
  protected get selector() {
    return `input:radio, input:checkbox[${this.dataCheckFieldName}], select:has(option[${this.dataCheckFieldName}])`;
  }

  preInit() {
    $(document).on('change', this.selector, (event) => {
      let $this = $(event.target);

      if ($this.attr('type') === 'radio') {
        $(`input:radio[${this.dataCheckFieldName}][name="${$this.attr('name')}"]`).each((i, item) => this.toggleField(i, item));
      } else if ($this.attr('type') === 'checkbox') {
        $(`input:checkbox[${this.dataCheckFieldName}][name="${$this.attr('name')}"]`).each((i, item) => this.toggleField(i, item));
      } else {
        $this.find(`option[${this.dataCheckFieldName}]`).each((i, item) => this.toggleField(i, item));
      }
      $this.trigger('dataRevealed');
    });
  }

  init() {
    this.toggleAllFields();
  }

  // --------------------------------------------------------------------
  // Data Reveal
  // --------------------------------------------------------------------
  toggleField(index, field) {
    let $field = $(field);
    let checkIndex = $field.data(this.dataCheckFieldName.split('-').splice(1).join('-'));
    let $parentContainer = this.getDefaultParentContainer();

    // the purpose of parent class and selector are to limit the scope of data reveal to a single parent
    // in case it's a repeatable and we don't want to affect other siblings
    // the class then gets added or removed to the parent in case we want particular styling for this container
    let $parentSelector = $field.data('parent-selector');
    let $parentClass = $field.data('parent-class');
    if ($parentSelector) {
      $parentContainer = $field.closest($parentSelector);
    }

    // all elements that could be affected by changing that state of the check target element
    let $revealFields = $parentContainer.find(`[${this.dataRevealFieldName}~="` + checkIndex + '"]');
    let $hideFields = $parentContainer.find(`[${this.dataHideFieldName}~="` + checkIndex + '"]');

    // for each field that may be revealed or hidden by the reveal target element

    let $revealCheckFields = this.checkFields($revealFields, $parentContainer, this.dataRevealFieldName);
    let $hideCheckFields = this.checkFields($hideFields, $parentContainer, this.dataHideFieldName);

    this.changeState($revealFields, $revealCheckFields, 'show', $parentContainer, $parentClass);
    this.changeState($hideFields, $hideCheckFields, 'hide', $parentContainer, $parentClass);
    $(document).trigger("fieldChange");
  }

  changeState($fields, $checkFields, state, $parentContainer, $parentClass) {
    // if any check field for this reveal field is checked, then reveal field
    if ($checkFields.filter((_, field) => $(field).is(":checked")).length > 0) {
      if (state == 'show') {
        $fields.show();
        this.enableInputs($fields)
      } else {
        $fields.hide();
        this.disableInputs($fields);
      }
      if ($parentClass) {
          $parentContainer.addClass($parentClass);
      }

    } else {
      if (state == 'show') {
        // else hide the reveal field (when no check fields that could affect this reveal field are checked)
        $fields.hide();
        this.disableInputs($fields);
        if ($parentClass) {
            $parentContainer.removeClass($parentClass);
        }
        this.blankOutValues($fields);
      } else {
        $fields.show();
        this.enableInputs($fields);
        if ($parentClass) {
            $parentContainer.removeClass($parentClass);
        }
      }
    }

  }

  disableInputs(fields){
    fields.find('input, select').each(function () {
      //your code here
      $(this).prop("disabled", true);


    });
  };

  enableInputs(fields){
    fields.find('input, select').each(function () {
      //your code here
      $(this).prop("disabled", false);


      });
  }

  checkFields(fields, $parentContainer, fieldName) {
    let revealIds: Array<string> = [];
    fields.each((ind, revealField) => {
      let $field = $(revealField);
      // get all reveal field items (an element may be controlled by more than one check target element)
      let revealIndexes = $field.data(fieldName.split('-').splice(1).join('-')).toString().split(" ");

      // gather all reveal target elements of the current reveal field
      revealIndexes.forEach(index => {
          if (revealIds.indexOf(index) == -1) {
              revealIds.push(index);
          }
      });
    });
    let $checkFields = $();

    revealIds.forEach((item) => {
        $checkFields = $checkFields.add($parentContainer.find(`[${this.dataCheckFieldName}~="${item}"]`));
    });
    return $checkFields
  }

  protected toggleAllFields() {
    let $toggleFields = $(this.selectorAll);
    for (var i = 0; i < $toggleFields.length; i++) {
      this.toggleField(i, $toggleFields[i]);
    }
  }

  protected blankOutValues($item) {
    $item.find('.affirmation').prop('checked', false);
    $item.find("input:text").val("");
    $item.find("select").each((i, select) =>{
      let $select = $(select);
      if($select.val() != ""){
        if (!$select.hasClass("reveal-no-clear")) {
          $select.val("");
          $select.trigger("change")
        }

      }
    });
    // $item.find('#statements_annual_statement_is_secretary_in_executive_true, #statements_annual_statement_is_secretary_in_executive_false').prop('checked', false);
    // $item.find(`select[name='statements_annual_statement[commission_board]'] option`).first().prop('selected', true);
    // $item.find(':input').not(':checkbox, [name="authenticity_token"], :radio, [data-reveal-except="true"]').val("");
    // $item.find('input:radio, input:checkbox').not('[data-reveal-except="true"]').prop('checked', false);
  }

  protected getDefaultParentContainer(): JQuery<HTMLElement> | JQuery<Document> {
    return $(document);
  }
}

let dataRevealFields = new DataRevealFields();
dataRevealFields.preInit();
$(document).on('turbo:load turbo:render fieldsAdded', () => dataRevealFields.init());
